import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@ff-os/shared-react/components/icons/Icon";
import { SelectedAccessoryForOptionsGroup } from "./accessory-option-group/SelectedAccessoryForOptionsGroup";
import { SelectedVariantForOptionsGroup } from "./variant-option-group/SelectedVariantForOptionsGroup";
import styles from './PhotoPrintOptionGroupTitle.module.scss';

export const PhotoPrintOptionGroupTitle = ({
    groupId,
    sizeId,
    hasAccessoryApplied,
    onClick
}: PhotoPrintsGroupProps) => {

    const { t } = useTranslation();

    return (
        <>
            { hasAccessoryApplied ? (
                <span className={`${styles.title} cursor-default`}>
                    <h4 className={styles.header}>{t('photo_prints.order_as')}</h4>
                    <SelectedAccessoryForOptionsGroup sizeId={sizeId} />
                </span>
            ) : (
                <span onClick={onClick} className={styles.title}>
                    <h4 className={styles.header}>{t('photo_prints.order_as')}</h4>
                    <SelectedVariantForOptionsGroup groupId={groupId} />
                    <Icon type="general-ui-pencil" className={styles.inlineFlex} />
                </span>
            )}
        </>
    );
};

type PhotoPrintsGroupProps = {
    groupId: string;
    sizeId: string;
    hasAccessoryApplied?: boolean;
    hasAccessoryWithSize?: boolean;
    onClick?: () => void;
};